import {
  ILinearScalingFieldConfigurationClient,
  ILinearScalingFieldConfigurationServer,
} from "./interface";

export const transformLinearScalingFieldConfigClientToServer = (
  fieldConfigClient: ILinearScalingFieldConfigurationClient
): ILinearScalingFieldConfigurationServer => {
  const {
    lowerScale,
    upperScale,
    lowerScaleLabel,
    upperScaleLabel,
    initialValue,
  } = fieldConfigClient;
  const fieldConfigServer = {
    lowerScale: { selected: lowerScale },
    upperScale: { selected: upperScale },
    lowerScaleLabel: lowerScaleLabel,
    upperScaleLabel: upperScaleLabel,
    initialValue: initialValue,
  };
  return fieldConfigServer;
};
export const transformLinearScalingConfigServerToClient = (
  fieldConfigServer: ILinearScalingFieldConfigurationServer
): ILinearScalingFieldConfigurationClient => {
  const {
    lowerScale,
    upperScale,
    lowerScaleLabel,
    upperScaleLabel,
    initialValue,
  } = fieldConfigServer;
  const fieldConfigClient = {
    lowerScale: lowerScale?.selected,
    upperScale: upperScale?.selected,
    lowerScaleLabel: lowerScaleLabel,
    upperScaleLabel: upperScaleLabel,
    initialValue: initialValue,
  };
  return fieldConfigClient;
};
